export const SETTINGS_TABS = [
  'student-board',
  'campaigns',
  'follow-up',
  'liteapp',
] as const;

export type SettingsTab = (typeof SETTINGS_TABS)[number];

/** Anything unrecognised lands on the first tab rather than a blank screen. */
export function parseSettingsTab(value: unknown): SettingsTab {
  return SETTINGS_TABS.find((tab) => tab === value) ?? 'student-board';
}
